import React from "react"
import { Row, Col } from "react-bootstrap"

import UseStories from "../../../hooks/useStoryBlogData"

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import StoryCard from "../../internal/storyCard/StoryCard"

const ThreeColumnBlogPanel = ({ blok, locale })=>{
  const stories = UseStories(locale)
  const blogs = []
  if(blok.blog_1) {
    let a = stories.find((d)=>{return d.uuid === blok.blog_1})
    if(a) {
      blogs.push(a)
    }
  }
  if(blok.blog_2) {
    let b = stories.find((d)=>{return d.uuid === blok.blog_2})
    if(b) {
      blogs.push(b)
    }
  }
  if(blok.blog_3) {
    let c = stories.find((d)=>{return d.uuid === blok.blog_3})
    if(c) {
      blogs.push(c)
    }
  }

  return (
    <PanelWrapper blok={blok}>
      <Row>
        {blogs.map((blog, index)=>{
          return (
            <Col key={index} md={4} >
              <StoryCard
                headline={blog.headline}
                date={""}
                image={null}
                thumbnail={blog.thumbnail}
                excerpt=""
                cta_text=""
                cta_link="" />
            </Col>
          )
        })}
      </Row>
    </PanelWrapper>
  )
}

export default ThreeColumnBlogPanel